import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link, Typography } from '@xprog/prensa';
import { parseVariants } from 'components/Assets/Utils';
import { TextProps } from './Text.types';
import NextLink from 'next/link';
import rehypeAutolinkHeadings from 'rehype-autolink-headings';

const Text: React.FC<TextProps> = props => {
  const THeading = (childProps) => {
    return (
      <Typography as={childProps.as} css={props.customCss} variant={parseVariants(props.variants)}>
        <strong>{childProps.children}</strong>
      </Typography>
    );
  };

  const TParagraph = (childProps) => {
    return (
      <Typography as={props.as} css={props.customCss} variant={parseVariants(props.variants)}>
        {childProps.children}
      </Typography>
    );
  };

  const TListItem = (childProps) => {
    return (
      <Typography as='li' css={props.customCss} variant={parseVariants(props.variants)}>
        {childProps.children}
      </Typography>
    );
  };

  const TCite = (childProps) => {
    return (
      <Typography as='cite' css={props.customCss} variant={parseVariants(props.variants)}>
        {childProps.children}
      </Typography>
    );
  };

  const TLink = (childProps) => {
    try {
      const href = childProps.href || '';
      const isCrossOrigin = href.match(childProps.siteDomain) ? false : true;

      const children = childProps?.children?.[0]?.props?.children?.[0]
        ? childProps.children[0].props.children[0]
        : childProps?.children?.[0] || '';

      const targetMatch = children?.match(/target:_(\w+)/);
      const target = targetMatch ? `_${targetMatch[1]}` : '_blank';
      const cleanChildren = children?.replace(/ target:_\w+/, '') || '';

      return (
        <Link
          component={NextLink}
          href={href}
          rel={isCrossOrigin ? 'nofollow' : undefined}
          target={target}
        >
          {cleanChildren}
        </Link>
      );
    } catch (error) {
      console.error('Erro ao processar link:', error);
      return (
        <Typography as="span" css={props.customCss} variant={parseVariants(props.variants)}>
          {childProps.children?.[0]?.props?.children?.[0] || ''}
        </Typography>
      );
    }
  };

  const TList = (childProps) => {
    return (
      <Typography as={props.as} css={{ width: '100%', ...props.customCss }}>
        {childProps.children}
      </Typography>
    );
  };

  const componentsMap = {
    a: TLink,
    p: TParagraph,
    h2: (props) => THeading({ ...props, as: 'h2' }),
    h3: (props) => THeading({ ...props, as: 'h3' }),
    h4: (props) => THeading({ ...props, as: 'h4' }),
    li: TListItem,
    cite: TCite,
    ul: TList,
    ol: TList,
  };

  const preprocessedValue = props?.value
    ?.replace(/\n\n/g, '\n')
    ?.replace(/^(\d+)\)\s*/gm, '\u200B$1) ')

  return (
    <ReactMarkdown components={componentsMap} remarkPlugins={[rehypeAutolinkHeadings]}>
      {preprocessedValue || props.children || ''}
    </ReactMarkdown>
  );
};

Text.defaultProps = {
  as: 'p',
  variants: ['articleParagraph-default', 'articleParagraph-desktop']
};

export default Text;
